/** @format */
import angular from 'angular';
import { calendarEventServiceModule, calendarSettingsModalServiceModule } from 'sis-components';
export const studentCalendarModule = 'student.calendar';

/**
 * This contains the remaining AngularJS dependencies needed for the student calendar since the root component is now in Angular.
 */
(function () {
  angular.module(studentCalendarModule, [calendarSettingsModalServiceModule, calendarEventServiceModule]);
})();